import { render } from "./UseTerms.vue?vue&type=template&id=7bf4ad12&scoped=true"
const script = {}

import "./UseTerms.vue?vue&type=style&index=0&id=7bf4ad12&scoped=true&lang=sass"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7bf4ad12"]])

export default __exports__